import React, { useState } from 'react';
import SplashBg from '../Assets/Backgrounds/Splash.png';
import Stars from '../Assets/Backgrounds/Stars.png';
import './splash.css';

import Logo from '../Assets/Imgs/Logo.png';
import Btn from '../Components/Common/Btn';
import Preload from '../Components/Layout/Preload';
import Settings from '../Components/Layout/Settings';

import Hover from '../Assets/Sounds/Hover.mp3';
import Click from '../Assets/Sounds/Click.mp3';
import BGSong from '../Assets/Sounds/seventeensplitcfg.wav';
import BGMusic from '../Components/Common/BackgroundMusic';


const Home = ({ musicVolume, setMusicVolume, sfxVolume, setSfxVolume }) => {
    
    
    const [showSettings, setShowSettings] = useState(false);

    return ( 
        <main className='HomeMain'>

            <div className='ResolutionOverlay'>
                <div className='ResolutionBox'>
                    <h2>DISPLAY WARNING</h2>
                    <hr />
                    <p>This tactical simulation is optimized for full HD environments.</p>
                    <p className='HighlightText'>Please switch your browser to Full Screen Mode (F11) or adjust your display resolution above 1080p (1920x1080) to play.</p>
                </div>
            </div>


            <BGMusic 
                src={BGSong} 
                volume={musicVolume / 100} 
                isPlaying={true} 
            />


            {showSettings && (
                <Settings 
                    musicVolume={musicVolume} 
                    setMusicVolume={setMusicVolume} 
                    sfxVolume={sfxVolume} 
                    setSfxVolume={setSfxVolume} 
                    onClose={() => setShowSettings(false)} 
                />
            )}
            
            <Preload />

            <div className='SplashBg'>
                <img className='Stars' src={Stars} alt="" />
                <img className='SplashImg' src={SplashBg} alt="" />
            </div>

            <section className='splashContent'>
                <img className='Logo' src={Logo} alt="" />

                <div className='SplashBtns'>
                    
                    <Btn 
                        BtnText='Start Game' 
                        BtnStyle='GoldBtn' 
                        BtnPath='/Intro' 
                        HoverSound={Hover} 
                        ClickSound={Click} 
                        sfxVolume={sfxVolume}
                    />
                    

                    <Btn 
                        BtnText='Options' 
                        BtnStyle='BlueBtn' 
                        HoverSound={Hover} 
                        ClickSound={Click} 
                        sfxVolume={sfxVolume}
                        onClick={() => setShowSettings(true)}
                    />
                    
                    <Btn 
                        BtnText='Quit' 
                        BtnStyle='BlueBtn' 
                        HoverSound={Hover} 
                        ClickSound={Click} 
                        sfxVolume={sfxVolume}
                        BtnPath='/'
                    />
                </div>

            </section>
        </main> 
    );
}
 
export default Home;